const createWidgetTemplateFactory = require('components-framework/widget/create_widget_template_factory');

module.exports = createWidgetTemplateFactory({
    viewClass: require('./view'),
    stopDetailsItemFactory: require('components/flights/stop_details_item/js/main.desktop'),
    templates: {
        main: require('components/flights/stop_details/templates/desktop/main.html'),
    },
});
